import 'svgxuse';
import './components/gallery-slider';
import './components/additional-locations-toggle';
import './components/modal';
import './components/reposition-cta-mobile';
import './components/location-autocomplete';
import './components/sticky-header-watcher';
import './components/top-doctors-only-input';
import './components/analytics';

import objectFitImages from 'object-fit-images';

document.addEventListener('DOMContentLoaded', function () {
	objectFitImages();
});
